function defaultValues() {
  return {
    phone: '',
    password: '',
  };
}

export default defaultValues;
